import React, {useEffect,useState,useContext,useRef,forwardRef,useImperativeHandle} from 'react'
import { formatDate,saveNewsItem, X_PADDING } from '../constants';
import { GlobalContext } from '../contexts/GlobalContext';
import NewsItem from './NewsItem';
import AddNewsItem from './AddNewsItem';

const NewsItems = ({newsItems}) => {
    const {editing} = useContext(GlobalContext);
    const [columns,setColumns] = useState(0);
    const [itemSize,setItemSize] = useState({});
    const [totalItems,setTotalItems] = useState(0);
    const newsItemsRef = useRef(null);

    const calWidth = (pw,mw,pa,sp,cols) => {
        if(cols === 0){
            return {w:0,cols:0};
        }
        let w = 0;
        let aw = pw - (pa * 2) - (sp * (cols - 1));
        w = aw/cols;
        if(w < mw && cols > 1) {
            cols -= 1;
            return calWidth(pw,mw,pa,sp,cols)
        } else {
            return {w,cols};
        }
    }

    useEffect(() => {
        let total = editing?1:0;
        total += newsItems? newsItems.length:0;
        setTotalItems(total);
    },[newsItems,editing])

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                let minWidth = 256;
                let paddingX = 0;
                let spaceX = 32;
                let parentWidth = entry.target.getBoundingClientRect().width;
                let {w,cols} = calWidth(parentWidth,minWidth,paddingX,spaceX,totalItems); 
                let h = (449*w)/640;
                setItemSize({width:w,height:h});
                setColumns(cols);
            }
        });

        if(newsItemsRef.current) {
            observer.observe(newsItemsRef.current)
        }
        return () => {
            observer.disconnect();
        }
    },[totalItems]);

  return (
    <div className={`flex flex-col w-full h-auto ${X_PADDING} space-y-8 py-8`}>
        <div className='w-10 h-[4px] rounded-full bg-theme'/>
        <div ref={newsItemsRef}
            className='flex flex-col space-y-8 w-full h-auto mx-auto '>
            {(() => {
                const rows = [];
                let rowKey = 0;
                for (let i = 0; i < totalItems;) {
                    const row = [];
                    if(columns < 1) {
                        break;
                    }
                    for (let j = 0; j < columns; j++) {
                        if(i < totalItems) {
                            if(newsItems && i < newsItems.length) {
                                row.push(<NewsItem key={i} newsItem={newsItems[i]} size={itemSize}/>);
                            } else {
                                row.push(<AddNewsItem key={i} size={itemSize}/>)
                            }
                            i++;
                        } else {
                            break;
                        }
                    }
                    rows.push(<div key={rowKey} className={`flex flex-row w-auto h-auto shrink-0 space-x-8`}>{row}</div>);
                    rowKey++;
                }
                return rows;
            })()}
        </div>
    </div>
  )
}

export default NewsItems